export type AlignerOption = 'active' | 'starter';

interface AlignerOptionMeta {
    value: AlignerOption;
    label: string;
    sub: string;
}

const ALIGNER_OPTIONS: AlignerOptionMeta[] = [
    {
        value: 'starter',
        label: 'Starter aligners',
        sub: 'Attachment template + 3 starter aligners'
    },
    {
        value: 'active',
        label: 'Active aligners',
        sub: 'Standard delivery: attachment template + active aligners'
    }
];

function RadioDot({ selected }: { selected: boolean }) {
    return (
        <span
            className={`w-4 h-4 rounded-full flex-shrink-0 mt-0.5 flex items-center justify-center transition-colors ${
                selected ? 'border-yellow-500 bg-yellow-400' : 'border-gray-400 bg-white'
            }`}
            style={{ borderWidth: '2px', borderStyle: 'solid' }}
        >
            {selected && <span className="w-1.5 h-1.5 rounded-full bg-gray-900" />}
        </span>
    );
}

interface AlignerOptionListProps {
    selected: AlignerOption | null;
    onSelect: (value: AlignerOption) => void;
    disabled: boolean;
}

export function AlignerOptionList({ selected, onSelect, disabled }: AlignerOptionListProps) {
    return (
        <div>
            <div className="text-[11px] font-bold uppercase tracking-wider text-gray-400 mb-2">
                Select an aligner option
            </div>
            <div className="flex flex-col gap-2" role="radiogroup" aria-label="Aligner option">
                {ALIGNER_OPTIONS.map(({ value, label, sub }) => {
                    const isSelected = selected === value;
                    return (
                        <button
                            type="button"
                            key={value}
                            role="radio"
                            aria-checked={isSelected}
                            onClick={() => onSelect(value)}
                            disabled={disabled}
                            className={`text-left flex items-start gap-3 px-3.5 py-3 rounded-lg border transition-colors disabled:opacity-50 ${
                                isSelected
                                    ? 'border-yellow-400 bg-yellow-50'
                                    : 'border-gray-200 bg-white hover:border-gray-400'
                            }`}
                            style={{ borderWidth: '1.5px' }}
                        >
                            <RadioDot selected={isSelected} />
                            <div className="flex-1 min-w-0">
                                <div
                                    className={`text-sm font-semibold ${isSelected ? 'text-gray-900' : 'text-gray-700'}`}
                                >
                                    {label}
                                </div>
                                <div className="text-xs text-gray-500 mt-0.5 leading-snug">
                                    {sub}
                                </div>
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
